import { Component, OnInit } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-reg-dashboard',
  templateUrl: './reg-dashboard.component.html',
  styleUrls: ['./reg-dashboard.component.scss']
})
export class RegDashboardComponent implements OnInit {

  userRecord: any[] | undefined;
    userRecordCount!: any;
    public isCollapsed = false;
    metrics!: any[];
    awpRecord: any[] | undefined;
    awpRecordCount!: any;
    trainingRecord: any[] | undefined;
    trainingRecordCount!: any;
    testingRecord: any[] | undefined;
    testingRecordCount!: any;
    regionName:any
    regionCode:any
    doughnutChartLabels:any;
    doughnutChartData:any;
    doughnutChartType:any;
  
    constructor(private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService) {
      debugger
      var test_total = 0;
      var user_total = 0;
      var awp_total = 0;
      var train_total = 0;
      this.regionName = localStorage.getItem("REGIONNAME")
      var regionCode=localStorage.getItem("REGIONCODE");
      var stateCode = this.authService.getState();
      this.fswService.getVehicleByRegion(regionCode).subscribe((data: any[]) => {
        this.spinnerService.show();
        this.userRecord = data;
        this.userRecord.forEach(function (value) {
              
          user_total = user_total + value.total;
        }); 
        console.log(user_total);
        this.userRecordCount = user_total;
        //Testing Start
        this.fswService.getTestingByRegion(regionCode)
          .subscribe(res => {
            debugger
            
            this.testingRecord = res;
            
            this.testingRecord.forEach(function (value) {
              
              test_total = test_total + value.total;
            }); 
            console.log(test_total);
            this.testingRecordCount = test_total;
            //Testing End
            //Training Start
            this.fswService.getTrainingByRegion(regionCode)
              .subscribe(res => {
                debugger
                this.trainingRecord = res;
                this.trainingRecord.forEach(function (value) {
              
                  train_total = train_total + value.total;
                });
                this.trainingRecordCount = train_total;
                //Training End
                //AWP Start
                this.fswService.getawpListCount(stateCode)
                  .subscribe(res => {
                    debugger
                    this.awpRecord = res;
                    this.awpRecord.forEach(function (value) {
              
                      awp_total = awp_total + value.total;
                    });
                    this.awpRecordCount = awp_total;
                    this.spinnerService.hide();
                    //AWP End
                    this.doughnutChartLabels = ['Testing', 'Trainings', 'Awareness Programs', 'Vehicles'];
                    this.doughnutChartData = [this.testingRecordCount, this.trainingRecordCount, this.awpRecordCount, this.userRecordCount];
                    this.doughnutChartType = 'doughnut';
  
                    this.metrics = [
                      {
                        title: 'Total Vehicle Registered',
                        value: this.userRecordCount,
                        color: 'text-primary',
                        icon: 'far fa-eye',
                        variation: this.userRecordCount,
                        backgroundColor: '#00c1ff'
                      },
                      {
                        title: 'Total Testing Done',
                        value: this.testingRecordCount,
                        color: 'text-info',
                        icon: 'fas fa-mouse-pointer',
                        variation: 2,
                        backgroundColor: 'rgb(255 168 0)'
                      },
                      {
                        title: 'Total Training Conducted',
                        value: this.trainingRecordCount,
                        color: 'text-success',
                        icon: 'fas fa-magnet fa-rotate-90',
                        variation: 3,
                        backgroundColor: 'rgb(148 0 255 / 58%)'
                      },
                      {
                        title: 'Total Aware Program Conducted',
                        value: this.awpRecordCount,
                        color: 'text-secondary',
                        icon: 'fas fa-magnet fa-rotate-90',
                        variation: 3,
                        backgroundColor: '#dc3545'
                      }
                    ];
                  })
              })
          })
      })
      //this.fswService.getTrainingList(this.userName)
      // .subscribe(res => {
      // debugger
      //    this.trainings = res;
  
      // })
    }
    
    public barChartOptions = {
      scaleShowVerticalLines: false,
      responsive: true
    };
    public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
    public barChartType = 'bar';
    public barChartLegend = true;
    public barChartData = [
      {data: [65, 59, 80, 81, 56, 55, 40], label: 'Pass Samples'}
      //,{data: [28, 48, 40, 19, 86, 27, 90], label: 'Fail Samples'}
    ];
  
    // Metrics Variables
  
    panels = [
      { title: 'Recently subscribers', id: 'recently-subscribers-panel' },
      { title: 'Twitter trends', id: 'twitter-trends-panel' },
      { title: 'Most viewed youtube videos', id: 'most-viewed-yt-videos-panel' },
      { title: 'Facebook audience growth', id: 'fb-audience-growth-panel' }
    ];

    ngOnInit() { }
  

}